export default __webpack_public_path__ + "static/media/Group2.65324f81.svg";